import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useRouteMatch } from 'react-router-dom';
import { faHome } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome/index';
import {
  getCurrentClub,
  getCurrentClubPlayerAccount
} from '../../../../../../store/selectors';
import configs from '../../../../../../config/config';
import { useSelector, useDispatch } from 'react-redux';
import BalanceField from '../../../../Counter/components/BalanceField';
import { requestRefreshAccountBalance } from '../../../../../../store/actionCreators/account';

const CloseHeader = ({ onClose, type }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const clubPlayer = useSelector(getCurrentClubPlayerAccount);
  const playerBalance =
    clubPlayer &&
    clubPlayer.wallets[0].balance;
  const [isLoading, setIsLoading] = useState(false);
  const currentClub = useSelector(getCurrentClub);
  const match = useRouteMatch();
  const returnBackText =
    match.url.indexOf('club') > -1 ? t('returnToClubLobby') : t('returnToHomePage');

  const refreshBalance = useCallback(() => {
    const accountData = {
      username: currentClub.playerAccount.username,
      skinId: currentClub.playerAccount.clubId,
      token: currentClub.playerAccount.token
    };
    dispatch(requestRefreshAccountBalance({ accountData }));
  }, [dispatch]);

  useEffect(() => {
    setIsLoading((currentClub && currentClub.isLoading) || false);
  }, [currentClub]);

  return (
    <div className="topRow">
      <span className={'arrowIcon'} onClick={onClose}>
        <FontAwesomeIcon icon={faHome} color="white"></FontAwesomeIcon>
        <span className="back-text">{returnBackText}</span>
      </span>
      {type && type === 'sports' && (
        <div className={`balance`}>
          <span
            className={`refresh ${isLoading && 'loading'}`}
            onClick={refreshBalance}
          ></span>
          <BalanceField role="player" amount={playerBalance} />
        </div>
      )}
    </div>
  );
};

export default CloseHeader;
